'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIErrorMessage = require('UIComponents/error/UIErrorMessage');

var _UIErrorMessage2 = _interopRequireDefault(_UIErrorMessage);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorState = function (_Component) {
  _inherits(ErrorState, _Component);

  function ErrorState() {
    _classCallCheck(this, ErrorState);

    return _possibleConstructorReturn(this, (ErrorState.__proto__ || Object.getPrototypeOf(ErrorState)).apply(this, arguments));
  }

  _createClass(ErrorState, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _UIErrorMessage2.default,
        null,
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(_FormattedMessage2.default, { message: 'conversationsUI.messagePreview.error.title' })
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(_FormattedMessage2.default, { message: 'conversationsUI.messagePreview.error.description' })
        )
      );
    }
  }]);

  return ErrorState;
}(_react.Component);

exports.default = ErrorState;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/message-preview/components/ErrorState.js
// module id = 1215
// module chunks = 3